import * as types from './project-tasks.types';
export const projectTasksPageSelectors: types.IProjectTasksPageSelectors = {
  selectProjectTasks: (state) => state.page.projectTasks.projectTasksIds,
};
